import useStore from './_store';
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import util from '../../common/util';
import { normal } from '../defaultSpacing';
import { mapAsyncData } from '../../plugins/asyncData';
import {  asyncData, fetchData } from './asyncData';
const LESS_STEP = 5;

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-search-seo'
    },
    asyncData: mapAsyncData(asyncData),
    // mixins: [getIndex()],
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "siteId": "siteId"
        }),
        ...mapState({
            "seoData": store => store.seoData
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        isDetailInfo() {
            return !!this.$root.moduleData.find(
                m => m.name === 'md-detail-info'
            );
        },
        showModule() {
            for (let item of this.originList) {
                if (Array.isArray(item) && item.length > 0) {
                    return true; 
                }
            }
            return false;
        },
        inPopDetailPage() {
            return util.inPopDetailPage;
        },
        // for pc
        showMoreBtn() {
            for (let item of this.originList) {
                if (Array.isArray(item) && item.length > 5) {
                    return true; 
                }
            }
            return false;
        },
        TYPES({ page }) {
            return [
                {
                    type: 'aggCityState',
                    label: this.$t('md-search-seo.nearbyCities')
                },
                {
                    type: 'aggZipcode',
                    label:
                        page.country === this.$t('md-search-seo.canada')
                            ? this.$t('md-search-seo.nearbyPostalCodes')
                            : this.$t('md-search-seo.nearbyZipCodes')
                },
                {
                    type: 'aggCitySubdivision',
                    label: this.$t('md-search-seo.nearbyNeighborhoods')
                }
            ];
        },
        originList({ seoData }) {
            return seoData.map(d => d)
        },
        nearbyList({ originList, TYPES, moreStatus, moreStatusForMobile }) {
            if (!this.isMobileSize) {
                return originList.map((d, index) => ({
                    title: TYPES[index].label,
                    list: moreStatus ? d : d.slice(0, LESS_STEP)
                }));
            } else {
                return originList.map((d, index) => ({
                    title: TYPES[index].label,
                    list: moreStatusForMobile[index]
                        ? d
                        : d.slice(0, LESS_STEP)
                }));
            }
        }
    },
    props: {
        inMapList: {
            default: false
        },
        insight: {
            default: false
        }
    },
    data: function() {
        return {
            ...normal,
            fullColumn: false,
            mobileNoMargin: false,
            moreStatus: false,
            moreStatusForMobile: [false, false, false]
        };
    },
    methods: {
        ...rootMapActions(usePageStore, ['findFirstSearchBarData']),
        toggleMore() {
            this.moreStatus = !this.moreStatus;
            this.toggleData(this.moreStatus);
        },
        toggleData() {
            this.nearbyList = this.originList.map((d, index) => ({
                title: this.TYPES[index].label,
                list: this.moreStatus ? d : d.slice(0, LESS_STEP)
            }));
        },
        mobileToggleMore(index) {
            const status = !this.moreStatusForMobile[index];
            this.moreStatusForMobile.splice(index, 1, status);
            this.mobileToggleData(index, status);
        },
        mobileToggleData(index, status) {
            const origin = this.originList[index];
            this.nearbyList[index].list = status
                ? origin
                : origin.slice(0, LESS_STEP);
        },
        processParams(condition) {
            let params = {
                listingType: this.resultListingType(condition.listingSource),
                siteId: this.siteId,
                listingIds: this.pageLocation.query.listingIds || ''
            };
            params = {
                ...params,
                ...condition
            };
            delete params.rect;
            delete params.mapSearch;
            delete params.listingSource;
            return params;
        },
        ...mapAsyncData({
            fetchData
        }),
        resultListingType(listingSource = '') {
            let listingType = '';
            listingSource = listingSource
                .toLowerCase()
                .replace(/^\d\+/, '')
                .replace(/\+/g, ' ');
            listingType = util.getListingTypeFromListingSource(listingSource)
            return listingType;
        }
    },
    beforeMount() {
        if (!this.isDetailInfo) {
            let searchModule = this.findFirstSearchBarData();
            if (searchModule) {
                let fn = async conditions => {
                    let params = this.processParams(conditions.condition || {});
                    this.fetchData(params);
                }
                this.unConditionChange =  searchModule.blockOb?.last('conditionChange', fn);
                if (!this.insight) {
                    this.unSearchSeo =  searchModule.blockOb?.last('searchSeoInitData', fn);
                }
            }
        }
    },
    beforeDestroy() {
        this.unConditionChange && this.unConditionChange();
        this.unSearchSeo && this.unSearchSeo();
    }
};
